module.exports = ['$scope', '$rootScope', 'feeSchedule', ($scope, $rootScope, feeSchedule) ->
  months = 12
  $scope.investmentValue = [
    1000, 1500, 2000, 2500, 3000, 3500, 4000, 4500, 5000,
    5500, 6000, 6500, 7000, 7500, 8000, 8500, 9000, 9500, 10000,
    15000, 20000, 25000, 30000, 35000, 40000, 45000, 50000,
    55000, 60000, 65000, 70000, 75000, 80000, 85000, 90000, 95000, 100000,
    125000, 150000, 175000, 200000, 225000, 250000, 275000, 300000, 325000,
    350000, 375000, 400000, 425000, 450000, 475000, 500000, 550000,
    600000, 650000, 700000, 750000, 800000, 850000, 900000, 950000, 1000000,
    1100000, 1200000, 1300000, 1400000, 1500000, 1600000, 1700000, 1800000, 1900000,
    2000000,
  ];
  $scope.wealthBarMER = feeSchedule.wealthBarMER
  $scope.mutualFundMER = feeSchedule.mutualFundMER - feeSchedule.wealthBarMER
  $scope.investment = 20000
  $scope.showSavings = false
  $scope.cta = 'Start Saving'
  $scope.rangeValue = 20

  $scope.calculateFees = ->
    $scope.monthlyFee = feeSchedule.calculateFees($scope.investment)/months
    $scope.feePercentage = feeSchedule.calculateFees($scope.investment)/$scope.investment
    $scope.blendedRate = feeSchedule.calculateBlendedRate($scope.investment)
    $scope.traditionalMonthlyFee = ($scope.investment * $scope.mutualFundMER)/months

    $scope.savings = $scope.investment * feeSchedule.mutualFundMER - $scope.monthlyFee * months -
      $scope.investment * feeSchedule.wealthBarMER

    # TODO: Figure a way that doesn't rely on hardcoded values like this
    $scope.tier = switch $scope.feePercentage
      when 0 then 'first-tier'
      when 0.006 then 'second-tier'
      when 0.004 then 'third-tier'
      when 0.0035 then 'last-tier'

  $scope.$watch 'investment', ->
    $scope.calculateFees()

  $scope.$watch 'rangeValue', ->
    $scope.investment = $scope.investmentValue[$scope.rangeValue]
]
